
import { isNavLinkActive, navLinkProps } from '@layouts/utils'


export default function useVerticalNavMenuLink(item) {
  const isActive = ref(false)
  const route = useRoute();
  const linkProps = navLinkProps(item)

  const updateIsActive = () => {
    isActive.value = isNavLinkActive(item)
  }

  watch(route, () => {
    updateIsActive();
  },{inmediate:true})

  return {
    isActive,
    linkProps,
    updateIsActive,
  }
}
